// src/components/settings/SettingsGeneral.jsx
import React, { useState } from "react";
import { getProfile, updateProfile } from "../Stores/profileStore";

const SettingsGeneral = () => {
  const [profile, setProfile] = useState(() => getProfile());
  const [editing, setEditing] = useState(false);

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setProfile((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    const updated = updateProfile(profile);
    setProfile(updated);
    setEditing(false);
  };

  const handleCancel = () => {
    setProfile(getProfile());
    setEditing(false);
  };

  return (
    <div className="profile-settings">
      <div className="profile-header-title">
        <h1>Perfil</h1>
      </div>

      <form className="profile-form" onSubmit={handleSave}>
        <div className="profile-form-row">
          <label className="profile-label">Nombre</label>
          <input
            type="text"
            className="profile-input"
            value={profile.nombre}
            onChange={handleChange("nombre")}
            disabled={!editing}
          />
        </div>

        <div className="profile-form-row">
          <label className="profile-label">Apellido paterno</label>
          <input
            type="text"
            className="profile-input"
            value={profile.apellidoPaterno}
            onChange={handleChange("apellidoPaterno")}
            disabled={!editing}
          />
        </div>

        <div className="profile-form-row">
          <label className="profile-label">Apellido materno</label>
          <input
            type="text"
            className="profile-input"
            value={profile.apellidoMaterno}
            onChange={handleChange("apellidoMaterno")}
            disabled={!editing}
          />
        </div>

        <div className="profile-form-row">
          <label className="profile-label">Correo electrónico</label>
          <input
            type="email"
            className="profile-input"
            value={profile.email}
            onChange={handleChange("email")}
            disabled={!editing}
          />
        </div>

        <div className="profile-form-row">
          <label className="profile-label">Teléfono</label>
          <input
            type="text"
            className="profile-input"
            value={profile.telefono}
            onChange={handleChange("telefono")}
            disabled={!editing}
          />
        </div>

        <div className="profile-form-row">
          <label className="profile-label">Extensión</label>
          <input
            type="text"
            className="profile-input"
            value={profile.extension}
            onChange={handleChange("extension")}
            disabled={!editing}
          />
        </div>

        <div className="profile-form-row">
          <label className="profile-label">Área</label>
          <input
            type="text"
            className="profile-input"
            value={profile.area}
            onChange={handleChange("area")}
            disabled={!editing}
          />
        </div>

        <div className="profile-form-row">
          <label className="profile-label">Puesto</label>
          <input
            type="text"
            className="profile-input"
            value={profile.puesto}
            onChange={handleChange("puesto")}
            disabled={!editing}
          />
        </div>

        <div className="profile-form-row">
          <label className="profile-label">Ubicación</label>
          <input
            type="text"
            className="profile-input"
            value={profile.ubicacion}
            onChange={handleChange("ubicacion")}
            disabled={!editing}
          />
        </div>

        <div className="profile-actions">
          {!editing ? (
            <button
              type="button"
              className="qe-btn qe-btn-outline"
              onClick={() => setEditing(true)}
            >
              Editar datos
            </button>
          ) : (
            <>
              <button
                type="button"
                className="qe-btn qe-btn-secondary"
                onClick={handleCancel}
              >
                Cancelar
              </button>
              <button type="submit" className="qe-btn qe-btn-primary">
                Guardar cambios
              </button>
            </>
          )}
        </div>
      </form>
    </div>
  );
};

export default SettingsGeneral;
